import 'hammerjs';

import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

// import { FileSelectDirective  } from 'ng2-file-upload';
import { MomentModule } from 'ngx-moment'; // 日付フォーマット
// import { BlobModule } from 'angular-azure-blob-service';
// import { Adal6Service, Adal6HTTPService } from 'adal-angular6';
// import { LocalDatePipe } from './localdate.pipe';

import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';
import { InMemoryDataService } from './in-memory-data.service';

import { AppMaterialModule } from './app.material.module';
import { AppComponent, DialogContentComponent } from './app.component';
// import { AppComponent} from './app.component';
// import { DialogContentComponent } from './dialog-content.component';

@NgModule({
  declarations: [
    AppComponent, DialogContentComponent, // FileSelectDirective, LocalDatePipe
  ],
  entryComponents: [DialogContentComponent],
  imports: [
    BrowserModule,
    FormsModule,
    AppMaterialModule,
    BrowserAnimationsModule,
    HttpClientModule,
    MomentModule,
      // The HttpClientInMemoryWebApiModule module intercepts HTTP requests
      // and returns simulated server responses.
      // Remove it when a real server is ready to receive requests.
      // HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, { dataEncapsulation: false })
    HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, { passThruUnknownUrl: true })
      // , BlobModule.forRoot()
    ],
  providers: [
    // {provide: LOCALE_ID, useValue: 'ja-JP'}
    /*
    Adal6Service,
    {
      provide: Adal6HTTPService,
      useFactory: Adal6HTTPService.factory,
      deps: [Adal6Service]
    }
    */
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
